import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import Footer from "../layout/Footer";
import Contact from "./Contact";

const ContactPage = ({ auth: { isAuthenticated } }) => {
  return (
    <div className="">
      <Helmet>
        <title>Contact Us</title>
      </Helmet>
      <div className="min-h-screen w-full my-[4rem] md:py-8 md:my-0 md:ml-[5rem] bg-neutral-50">
        <Contact />
      </div>
      {!isAuthenticated && <Footer />}
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(ContactPage);
